import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faHelmetSafety,
  faXmark,
  faChartSimple,
  faChevronDown,
  faChevronUp,
  faCalendar,
  faFileCirclePlus,
  faBolt,
  faFolderOpen,
  faCircleUser,
  faAnglesLeft,
  faAnglesRight,
} from '@fortawesome/free-solid-svg-icons';
import GreeniaLogo from '../../assets/images/greenia-logo.svg';
import LogoNetMeet from '../../assets/images/logo-netmeet.png';
// import ListaRinnovi from '../../assets/images/lista-rinnovi.png';
// import Portagolgio from '../../assets/images/portagolgio.png';
// import Tutorial from '../../assets/images/tutorial.png';
// import User from '../../assets/images/user.png';
// import message from '../../assets/images/message.png';
import { SidebarV2Styles } from './SidebarV2.styles';
import BellIcon from '../../assets/images/icons/BellIcon';
import {
  // POG-DISABLED: checkForUnAcceptedPog,
  unReadNotifications,
} from '../../features/utilities/utilitiesActions';
// import useAuth from '../../hooks/useAuth';
// POG-DISABLED: import {
// POG-DISABLED:   confirmAlert,
// POG-DISABLED:   generalAlertErrorToast,
// POG-DISABLED: } from '../utils/alerts';
// POG-DISABLED: import SimpleModal from './elements/SimpleModal';
// POG-DISABLED: import {
// POG-DISABLED:   apiAcceptPog,
// POG-DISABLED:   apiDownloadPogDocument,
// POG-DISABLED: } from '../../services/axios-client/axeCommons';
import StorageService from '../../services/StorageService';

const Storage = new StorageService();

const praticheRoutes = [
  '/fast-quotes',
  '/preventivi',
  '/quotazioni-aquistati',
  '/quote-semestrale-da-pagare',
];

const navLinkClassName = ({ isActive }) => (isActive ? 'active' : undefined);

// One sidebar component for both desktop and mobile: a persistent collapsible
// rail at >=tablet widths, and a slide-in drawer over a backdrop below it
// (see SidebarV2.styles.js). `isMobileOpen`/`onCloseMobile` are only relevant
// below the tablet breakpoint; the desktop collapse state is self-contained
// and persisted locally since it's a per-viewer convenience, not shared app
// state.
export default function SidebarV2({ isMobileOpen, onCloseMobile }) {
  // const {
  //   isUserSectionAB,
  //   hasBackoffice
  // } = useAuth();
  // POG-DISABLED: const { notificationsCount, messagesCount, unaccepted_pogs } = useSelector(
  const {
    notificationsCount,
    // messagesCount,
  } = useSelector(
    (store) => store.utilities,
  );
  // POG-DISABLED: const [downloaded_file, setDownloadedFile] = useState(false);
  const user = Storage.getUser();
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem('sidebar-collapsed') === '1';
    } catch {
      return false;
    }
  });
  const [openDropdown, setOpenDropdown] = useState(
    () => praticheRoutes.some((path) => location.pathname.startsWith(path)),
  );
  const isPraticheActive = praticheRoutes.some((path) => location.pathname.startsWith(path));

  // Mirrors the rail's own width onto a CSS var on :root so the sibling
  // page-content layout (DashboardTheme.styles.js) can offset itself without
  // prop-drilling the collapse state up through DashboardTheme.
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--sidebar-rail-width',
      collapsed ? '76px' : '260px',
    );
  }, [collapsed]);

  const persistCollapsed = (next) => {
    setCollapsed(next);
    try {
      localStorage.setItem('sidebar-collapsed', next ? '1' : '0');
    } catch {
      // ignore write failures (private mode / blocked storage)
    }
  };

  const toggleCollapsed = () => persistCollapsed(!collapsed);

  // The Pratiche sub-list has nowhere to render in the icon-only collapsed
  // rail (no room for a flyout), so clicking it there expands the rail
  // first instead of silently doing nothing.
  const togglePraticheDropdown = () => {
    if (collapsed) {
      persistCollapsed(false);
      setOpenDropdown(true);
      return;
    }
    setOpenDropdown((prev) => !prev);
  };

  // const loginToPanel = async () => {
  //   const res = await axe.post('/backoffice/signin');

  //   if (res.status !== 200) {
  //     generalAlertError(
  //       "Qualcosa e andato storto! Riprova o chiama l'amministratore dell sistema!",
  //     );
  //   }
  //   window.open(
  //     `${BACKOFFICE_PANEL_URL}/broker-back-office/login/${res.data.data.token}`,
  //     '_blank',
  //   );
  // };

  useEffect(() => {
    unReadNotifications();
    // POG-DISABLED: checkForUnAcceptedPog();
    setInterval(() => {
      unReadNotifications();
      // POG-DISABLED: checkForUnAcceptedPog();
    }, 60000);
  }, []);

  // POG-DISABLED: const downloadPogDocument = async (pog_id) => {
  // POG-DISABLED:   const response = await apiDownloadPogDocument(pog_id);
  // POG-DISABLED:   const alink = document.createElement('a');
  // POG-DISABLED:   alink.target = '_blank';
  // POG-DISABLED:   alink.href = response.data.data.data.content;
  // POG-DISABLED:   alink.download = response.data.data.data.filename;
  // POG-DISABLED:   alink.click();
  // POG-DISABLED:   setDownloadedFile(true);
  // POG-DISABLED: };

  // POG-DISABLED: const accept = async () => {
  // POG-DISABLED:   const response = await apiAcceptPog(unaccepted_pogs[0].id);
  // POG-DISABLED:   if (response.status !== 200) {
  // POG-DISABLED:     generalAlertErrorToast(
  // POG-DISABLED:       "Qualcosa è andato storto! Riprova o chiama l'amministratore del sistema",
  // POG-DISABLED:     );
  // POG-DISABLED:   } else {
  // POG-DISABLED:     window.location.reload();
  // POG-DISABLED:   }
  // POG-DISABLED: };

  // POG-DISABLED: const handleAccept = async () => {
  // POG-DISABLED:   confirmAlert(
  // POG-DISABLED:     'Premendo accetta confermi di aver letto il documento!',
  // POG-DISABLED:     () => accept(),
  // POG-DISABLED:     () => { },
  // POG-DISABLED:     'Conferma',
  // POG-DISABLED:     '#00a651',
  // POG-DISABLED:     true,
  // POG-DISABLED:   );
  // POG-DISABLED: };

  // POG-DISABLED: get first pog if array is not empty
  /* POG-DISABLED:
  const current_unaccepted_pogs = unaccepted_pogs.length > 0
    ? { ...unaccepted_pogs[0], downloaded_file: false }
    : null;
  if (current_unaccepted_pogs) {
    return (
      <>
        <SimpleModal
          show={current_unaccepted_pogs}
          setIsOpen={() => { }}
          extraClass="overlay-everything"
          hideCloseButton
        >
          <div className="container" style={{ overflowY: 'auto', maxHeight: '70vh', padding: '20px' }}>
            {current_unaccepted_pogs.is_urgent ? (
              <h4 className="badge bg-warning fs-6">
                È una questione urgente!
              </h4>
            ) : (
              ''
            )}
            <div className="row">
              <div className="col-md-12">
                <div
                  className=""
                  role="alert"
                  style={{
                    fontSize: current_unaccepted_pogs.is_urgent
                      ? '32px'
                      : '20px',
                    textTransform: 'capitalize',
                  }}
                >
                  {current_unaccepted_pogs.title}
                </div>
                <p>{current_unaccepted_pogs.description}</p>
              </div>
            </div>
            {downloaded_file ? (
              <div className="row">
                <div className="col-md-6">
                  <button
                    className="btn btn-success"
                    onClick={() => handleAccept()}
                  >
                    Accetta
                  </button>
                  <br />
                </div>
              </div>
            ) : (
              <>
                <button
                  className="cursor-pointer btn btn-success "
                  onClick={() => downloadPogDocument(current_unaccepted_pogs.id)}
                >
                  Scarica il documento
                </button>
                <br />
                <small>
                  {!downloaded_file
                    && 'Devi scaricare il documento per abilitare questo pulsante'}
                </small>
              </>
            )}
          </div>
        </SimpleModal>
      </>
    );
  }
  */

  return (
    <SidebarV2Styles $collapsed={collapsed} $mobileOpen={isMobileOpen}>
      <div className="backdrop" onClick={onCloseMobile} />
      <nav className="rail">
        <div className="rail-header">
          <Link onClick={onCloseMobile} className="logo-link" to="/">
            {user && [78, 119].includes(user?.id) ? (
              <img src={LogoNetMeet} alt="NetMeet Logo" />
            ) : (
              <img src={GreeniaLogo} alt="Greenia Logo" />
            )}
          </Link>
          <button type="button" className="collapse-toggle" onClick={toggleCollapsed} title={collapsed ? 'Espandi menu' : 'Comprimi menu'}>
            <FontAwesomeIcon icon={collapsed ? faAnglesRight : faAnglesLeft} />
          </button>
          <button type="button" className="mobile-close" onClick={onCloseMobile} aria-label="Chiudi menu">
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="nav-scroll">
          <ul className="nav-list">
            <li>
              <NavLink onClick={onCloseMobile} to="/notifications" className={navLinkClassName} title="Notifiche">
                <span className={notificationsCount > 0 ? 'text-danger' : ''}>
                  <BellIcon width="18px" height="18px" />
                </span>
                <span className="nav-label">Notifiche</span>
                {notificationsCount > 0 && (
                  <span className="notification-badge">{notificationsCount}</span>
                )}
              </NavLink>
            </li>

            <li>
              <NavLink onClick={onCloseMobile} to="/report" className={navLinkClassName} title="Report">
                <FontAwesomeIcon icon={faChartSimple} />
                <span className="nav-label">Report</span>
              </NavLink>
            </li>

            <li>
              <NavLink onClick={onCloseMobile} to="/quote" className={navLinkClassName} title="Nuovo preventivo">
                <FontAwesomeIcon icon={faFileCirclePlus} />
                <span className="nav-label">Nuovo preventivo</span>
              </NavLink>
            </li>

            <li>
              <NavLink onClick={onCloseMobile} to="/luce-gas" className={navLinkClassName} title="Luce Gas">
                <FontAwesomeIcon icon={faBolt} />
                <span className="nav-label">Luce Gas</span>
              </NavLink>
            </li>

            <li>
              <div
                className={`nav-row${isPraticheActive ? ' active' : ''}`}
                onClick={togglePraticheDropdown}
                title="Pratiche"
              >
                <FontAwesomeIcon icon={faFolderOpen} />
                <span className="nav-label">Pratiche</span>
                <span className="chevron">
                  <FontAwesomeIcon icon={openDropdown ? faChevronUp : faChevronDown} />
                </span>
              </div>
              {openDropdown && (
                <ul className="sub-list">
                  <li>
                    <NavLink onClick={onCloseMobile} to="/fast-quotes" className={navLinkClassName}>
                      <span className="nav-label">Fast Quote</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink onClick={onCloseMobile} to="/preventivi" className={navLinkClassName}>
                      <span className="nav-label">Preventivi</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink onClick={onCloseMobile} to="/quotazioni-aquistati" className={navLinkClassName}>
                      <span className="nav-label">Polizze Emesse</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink onClick={onCloseMobile} to="/quote-semestrale-da-pagare" className={navLinkClassName}>
                      <span className="nav-label">Pratiche semestrali</span>
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <NavLink onClick={onCloseMobile} to="/expirations" className={navLinkClassName} title="Scadenze">
                <FontAwesomeIcon icon={faCalendar} />
                <span className="nav-label">Scadenze</span>
              </NavLink>
            </li>

            {/* <li className="dropdown">
                  <Link
                    onClick={closeSidebar}
                    to="/ai-products-list"
                    className="list-group-item list-group-item-action py-2 ripple"
                  >
                    <FontAwesomeIcon icon={faHeadset} style={{ color: '#737476' }} size="lg" />
                    <span className="item">Chat Prodotti</span>
                  </Link>
                </li> */}

            <li>
              <NavLink onClick={onCloseMobile} to="/clients" className={navLinkClassName} title="Clienti">
                <FontAwesomeIcon icon={faUsers} />
                <span className="nav-label">Clienti</span>
              </NavLink>
            </li>

            {/* <li>
                <Link
                  onClick={closeSidebar}
                  to="/research-type"
                  className="list-group-item list-group-item-action py-2 ripple"
                >
                  <img className="item-img" src={researchIcon} alt="analysis" />
                  <span className="item">Analisi Rui</span>
                </Link>
              </li> */}

            <li>
              <NavLink onClick={onCloseMobile} to="/post-vendita" className={navLinkClassName} title="Post Vendita">
                <FontAwesomeIcon icon={faHelmetSafety} />
                <span className="nav-label">Post Vendita</span>
              </NavLink>
            </li>

            {/* <li>
                  <Link
                    onClick={closeSidebar}
                    to="/messages"
                    className="list-group-item list-group-item-action py-2 ripple"
                  >
                    <FontAwesomeIcon icon={faMessage} style={{ color: '#737476' }} size="lg" />
                    <span className="item">
                      Messaggi
                      {`(${messagesCount})`}
                    </span>
                  </Link>
                </li> */}

            <li>
              <NavLink onClick={onCloseMobile} to="/profile" className={navLinkClassName} title="Profilo">
                <FontAwesomeIcon icon={faCircleUser} />
                <span className="nav-label">Profilo</span>
              </NavLink>
            </li>

            {/* <li className="dropdown">
                  <Link
                    onClick={closeSidebar}
                    to="/useful-documents"
                    className="list-group-item list-group-item-action py-2 ripple"
                  >
                    <img className="item-img" src={User} alt="useful-documents" />
                    <span className="item">Documenti Utili</span>
                  </Link>
                </li> */}
            {/* <li>
                  <Link
                    onClick={closeSidebar}
                    to="/tutorial"
                    className="list-group-item list-group-item-action py-2 ripple"
                  >
                    <FontAwesomeIcon icon={faBook} style={{ color: '#737476' }} size="lg" />
                    <span className="item">Tutorial</span>
                  </Link>
                </li> */}
            {/* {isUserSectionAB && (
                  <li>
                    <Link
                      onClick={closeSidebar}
                      to="/brokers"
                      className="list-group-item list-group-item-action py-2 ripple"
                    >
                      <FontAwesomeIcon icon={faGlobe} style={{ color: '#737476' }} size="lg" />
                      <span className="item">Gestisci rete</span>
                    </Link>
                  </li>
                )} */}
            {/* {hasBackoffice && (
                  <li>
                    <div
                      onClick={() => {
                        loginToPanel();
                        closeSidebar();
                      }}
                      to="/tutorial"
                      className="list-group-item list-group-item-action py-2 ripple"
                      style={{ cursor: 'pointer' }}
                    >
                      <FontAwesomeIcon
                        className="item-img"
                        icon={faUserTie}
                        alt=""
                        color="#737476"
                      />
                      <span className="item fw-bold">Accedi A Backoffice</span>
                    </div>
                  </li>
                )} */}
          </ul>
        </div>
      </nav>
    </SidebarV2Styles>
  );
}
